import React from "react";

import {
  resourceMaturityList,
  resourceMaturityMeta,
} from "@examspark/common-meta";
import { SelectInput } from "@examspark/common-ui";

export const MaturitySelect = (
  props: React.ComponentProps<typeof SelectInput.Simple>,
) => {
  return (
    <SelectInput.Simple
      {...props}
      options={resourceMaturityList.map((s) => ({
        label:
          resourceMaturityMeta[s as keyof typeof resourceMaturityMeta]?.label ??
          "",
        value: s,
      }))}
      placeholder="Select Maturity..."
    />
  );
};
